export default __webpack_public_path__ + "static/media/piggy-bank-icon.6e80271e.svg";